<div
  class="photo-card p-4 flex flex-col gap-4 bg-white h-full box-border justify-between"
>
  <section class="photo-details flex flex-col">
    <div class="photo-card-image relative w-fit">
      <img [src]="photo.photoUrl" alt="Photo" class="h-40 w-40 object-cover" (click)="photoClick.emit()"/>

      <input
        type="checkbox"
        class="absolute top-2 right-2 w-5 h-5 z-9 accent-blue"
        [checked]="selected"
        (click)="$event.stopPropagation()"
        (change)="selectionChange.emit($event)"
      />
    </div>

    <section class="photo-info max-w-40">
      <div class="photo-description line-clamp-2 text-sm">
        {{ photo.description }}
      </div>

      <div class="photo-caption text-xs text-neptune-color-fg-muted line-clamp-2">
        <span>{{ photo.ecolabRepName }}</span>
        at
        <span>{{ photo.customerName }}</span>
      </div>
    </section>
  </section>

  <ng-container *ngIf="callType == SICallTypes.PhotoObservations">
    <section class="photo-report flex justify-start bottom-0">
      <a
        (click)="$event.stopPropagation()"
        class="flex items-center gap-2 no-underline"
        target="_blank"
        [href]="viewReportURL + photo.workOrderId + '/view'"
      >
        <span class="text-sm text-blue font-medium hover:underline">{{
          serviceCallLabel
        }}</span>
        <img
          src="/assets/shared-icons/neptune-icon-blue-chevron-right.svg"
          class="w-5 h-5 flex self-center"
        />
      </a>
    </section>
  </ng-container>
</div>
